import { UseQueryResult, useQuery } from 'react-query'
import useApi from 'hooks/useApi'
import { getCaseRoute } from 'dataSource/salesforce/routes'
import { useEffect, useState } from 'react'
import { transformedCaseData } from './utils'

const useFetchSalesforceCase = (
  storedCaseId: string,
  shouldFetchCaseDetails: boolean
): UseQueryResult<SalesForceCaseResults> => {
  const { request: caseRequest } = useApi({
    redirectOnUnauthorized: false,
  })
  const [prevData, setPrevData] = useState(null)

  const isValidCaseId = Boolean(storedCaseId) && storedCaseId !== 'undefined'
  const shouldFetch = shouldFetchCaseDetails && isValidCaseId

  const caseQueryData = useQuery<SfCase, Error, SalesForceCaseResults>(
    ['case', storedCaseId],
    () => getCaseData(caseRequest, storedCaseId),
    {
      enabled: shouldFetch,
      refetchOnWindowFocus: 'always',
      select(data) {
        return transformedCaseData(data, prevData)
      },
      isDataEqual(oldData, newData) {
        return (
          oldData?.Account?.LastModifiedDate ===
          newData?.Account?.LastModifiedDate
        )
      },
    }
  )

  useEffect(() => {
    setPrevData(caseQueryData?.data?.sfCase)
  }, [caseQueryData?.data?.sfCase])

  return caseQueryData
}

const getCaseData = async (caseRequest, id) => {
  if (!id || id === 'undefined' || id === 'null') {
    throw new Error('Case ID is required')
  }

  const response = await caseRequest.get(getCaseRoute(id))

  if (!response) {
    throw new Error('Unable to fetch case details')
  }

  if (response?.statusCode === 401) {
    throw new Error('Unauthorized')
  }

  return response
}

export default useFetchSalesforceCase
